var map = {
	"./Assign.svg": "./src/assets/icons/Assign.svg",
	"./Assign_with_Template.svg": "./src/assets/icons/Assign_with_Template.svg",
	"./Blinking_by_Label.svg": "./src/assets/icons/Blinking_by_Label.svg",
	"./Blinking_by_Product.svg": "./src/assets/icons/Blinking_by_Product.svg",
	"./Label_Info.svg": "./src/assets/icons/Label_Info.svg",
	"./Multi_Assign.svg": "./src/assets/icons/Multi_Assign.svg",
	"./Page_Flipping.svg": "./src/assets/icons/Page_Flipping.svg",
	"./PowerRailAssign.svg": "./src/assets/icons/PowerRailAssign.svg",
	"./PowerRailUnAssign.svg": "./src/assets/icons/PowerRailUnAssign.svg",
	"./Product_Info.svg": "./src/assets/icons/Product_Info.svg",
	"./SensorAssign.svg": "./src/assets/icons/SensorAssign.svg",
	"./SensorUnAssign.svg": "./src/assets/icons/SensorUnAssign.svg",
	"./Unassign.svg": "./src/assets/icons/Unassign.svg",
	"./extra_assign.svg": "./src/assets/icons/extra_assign.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";